import { Field, useFormikContext } from 'formik';
import React from 'react';
import Input from '../../../../components/input/Input';
import Button from '../../../../components/button/Button';
import { Select } from 'antd';
import { ConfigData } from '../../../../customhooks/investments/useInvestmentOptions';

const CompanyDetails = ({
    investmentOptions,
    isLoading
}: {
    investmentOptions: ConfigData;
    isLoading:boolean
}) => {
    const {
        values,
        errors,
        setFieldValue,
        touched,
        isValid,
        handleChange
    } = useFormikContext<any>();

    return (
        <div className='space-y-4 max-w-lg'>
            <h2 className='text-lg font-medium'>
                Lets start by getting your corporate identity and registration
                details
            </h2>

            <Field
                as={Input}
                isError={touched?.phoneNumber && errors?.phoneNumber}
                errorMessage={touched?.phoneNumber && errors?.phoneNumber}
                required
                type='text'
                label='Phone number'
                name='phoneNumber'
                value={values?.phoneNumber}
                onChange={handleChange}
            />

            <Field
                as={Input}
                isError={touched?.businessEmail && errors?.businessEmail}
                errorMessage={touched?.businessEmail && errors?.businessEmail}
                required
                type='email'
                label='Email Address'
                name='businessEmail'
                value={values?.businessEmail}
                onChange={handleChange}
            />

            <Field
                as={Input}
                isError={touched?.companyAddress && errors?.companyAddress}
                errorMessage={touched?.addressNumber && errors?.addressNumber}
                type='text'
                label='Company Address'
                name='companyAddress'
                value={values?.companyAddress}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('companyAddress', e.target.value);
                }}
            />

            <Field
                as={Input}
                isError={touched?.tinNumber && errors?.tinNumber}
                errorMessage={touched?.tinNumber ? errors?.tinNumber : ''}
                type='text'
                label='Tax Identification Number'
                name='tinNumber'
                value={values?.tinNumber}
                onChange={handleChange}
            />

            <div>
                <label
                    htmlFor='input-group-1'
                    className='block mb-2 text-sm font-medium text-gray700 text-left'
                >
                    Company Type
                </label>
                <Select
                    style={{ borderRadius: '8px' }}
                    className='w-full h-[45px] rounded-[8px]'
                    id='companyType'
                    options={investmentOptions?.clientSubType}
                    value={values.companyType}
                    onChange={(value) => {
                        const selected = investmentOptions?.clientSubType?.find(
                            (opt) => opt.value === value
                        );
                        setFieldValue('companyType', selected?.value);
                    }}
                    filterOption={(input, option) => {
                        if (!option) return false;
                        return option.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                />
            </div>

            <div>
                <label
                    htmlFor='input-group-1'
                    className='block mb-2 text-sm font-medium text-gray700 text-left'
                >
                    Category of Business
                </label>
                <Select
                    style={{ borderRadius: '8px' }}
                    className='w-full h-[45px] rounded-[8px]'
                    id='categoryOfBusiness'
                    options={investmentOptions?.categoryOfBusiness}
                    onChange={(value) => {
                        console.log(value);
                        const selected = investmentOptions?.categoryOfBusiness?.find(
                            (opt) => opt.value === value
                        );
                        setFieldValue('categoryOfBusiness', selected?.value);
                    }}
                    filterOption={(input, option) => {
                        if (!option) return false;
                        return option.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                    value={values.categoryOfBusiness}
                />
            </div>

            <Field
                as={Input}
                isError={
                    touched?.yearOfEstablishment && errors?.yearOfEstablishment
                }
                errorMessage={
                    touched?.yearOfEstablishment && errors?.yearOfEstablishment
                }
                required
                type='number'
                label='Year of Establishment'
                name='yearOfEstablishment'
                value={values?.yearOfEstablishment}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('yearOfEstablishment', e.target.value);
                }}
            />
            <div>
                <label
                    htmlFor='bank'
                    className='block mb-2 text-sm font-medium text-gray700 text-left'
                >
                    Annual Expected Income Range
                </label>
                <Select
                    style={{ borderRadius: '8px' }}
                    className='w-full h-[45px] rounded-[8px]'
                    id='incomeRange'
                    onChange={(value) => {
                        const selected = investmentOptions?.incomeRanges?.find(
                            (opt) => opt === value
                        );
                        setFieldValue('incomeRange', selected);
                    }}
                    options={investmentOptions?.incomeRanges?.map((opt) => ({
                        label: opt,
                        value: opt
                    }))}
                    value={values.incomeRange}
                    filterOption={(input, option) => {
                        if (!option) return false;
                        return option.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                />
                {touched.incomeRange && errors.incomeRange && (
                    <p className='text-xs text-red100'>
                        {errors.incomeRange as string}
                    </p>
                )}
            </div>

            <div>
                <label
                    htmlFor='bank'
                    className='block mb-2 text-sm font-medium text-gray700 text-left'
                >
                    Number of Employees
                </label>
                <Select
                    style={{ borderRadius: '8px' }}
                    className='w-full h-[45px] rounded-[8px]'
                    id='numberOfEmployees'
                    onChange={(value) => {
                        const selected = investmentOptions?.numbersOfEmployee?.find(
                            (opt) => opt.value === value
                        );
                        setFieldValue('numberOfEmployees', selected?.value);
                    }}
                    options={investmentOptions?.numbersOfEmployee}
                    value={values.numberOfEmployees}
                    filterOption={(input, option) => {
                        if (!option) return false;
                        return option.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                />
                {touched.numberOfEmployees && errors.numberOfEmployees && (
                    <p className='text-xs text-red100'>
                        {errors.numberOfEmployees as string}
                    </p>
                )}
            </div>

            <div className='pt-6 w-full'>
                <Button
                    text='Save and Continue'
                    className='w-full'
                    type='submit'
                    disabled={!isValid}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

export default CompanyDetails;
